@for (notice of notices; track notice) {
  <div>
    <div class="alert alert-{{notice.severity}}">
      {{notice.message}}
    </div>
  </div>
}